import { Table, Badge, Box } from "@chakra-ui/react";
import { Button, Input } from "@chakra-ui/react";
import { CiFilter } from "react-icons/ci";
import { FiDownload } from "react-icons/fi";
import { GoSortAsc } from "react-icons/go";
import { useNavigate } from "react-router-dom";

const pharmacyData = [
  {
    id: 1,
    name: "Naza Pharmacy",
    location: "Bwari, Abuja",
    lastDataSync: "24-10-2025, 10:00AM",
    status: "Active",
    compliance: "98%",
    inventoryAlerts: 100,
    topCategory: "Pain Relievers",
    riskLevel: "Normal",
  },
  {
    id: 2,
    name: "HealthPlus Pharmacy",
    location: "Victoria Island, Lagos",
    lastDataSync: "20-11-2025, 1:30PM",
    status: "Active",
    compliance: "95%",
    inventoryAlerts: 150,
    topCategory: "Antibiotics",
    riskLevel: "Normal",
  },
  {
    id: 3,
    name: "MediCare Pharmacy",
    location: "Garki, Abuja",
    lastDataSync: "15-12-2025, 3:00PM",
    status: "Inactive",
    compliance: "80%",
    inventoryAlerts: 75,
    topCategory: "Vitamins",
    riskLevel: "Normal",
  },
  {
    id: 4,
    name: "Wellness Pharmacy",
    location: "Benin City, Edo",
    lastDataSync: "30-10-2025, 11:00AM",
    status: "Active",
    compliance: "90%",
    inventoryAlerts: 200,
    topCategory: "Skin Care",
    riskLevel: "Normal",
  },
  {
    id: 5,
    name: "Trust Pharmacy",
    location: "Kaduna, Kaduna",
    lastDataSync: "05-01-2026, 9:00AM",
    status: "Active",
    compliance: "92%",
    inventoryAlerts: 120,
    topCategory: "Diabetes Care",
    riskLevel: "Normal",
  },
  {
    id: 6,
    name: "Caring Pharmacy",
    location: "Port Harcourt, Rivers",
    lastDataSync: "12-02-2026, 2:00PM",
    status: "Inactive",
    compliance: "85%",
    inventoryAlerts: 80,
    topCategory: "Allergy Relief",
    riskLevel: "Normal",
  },
  {
    id: 7,
    name: "Eagle Pharmacy",
    location: "Ibadan, Oyo",
    lastDataSync: "18-03-2026, 4:30PM",
    status: "Active",
    compliance: "88%",
    inventoryAlerts: 130,
    topCategory: "Cold Medications",
    riskLevel: "Normal",
  },
  {
    id: 8,
    name: "PrimeCare Pharmacy",
    location: "Abeokuta, Ogun",
    lastDataSync: "23-04-2026, 5:00PM",
    status: "Active",
    compliance: "91%",
    inventoryAlerts: 90,
    topCategory: "Heart Health",
    riskLevel: "Normal",
  },
  {
    id: 9,
    name: "Unity Pharmacy",
    location: "Enugu, Enugu",
    lastDataSync: "27-05-2026, 12:30PM",
    status: "Inactive",
    compliance: "83%",
    inventoryAlerts: 60,
    topCategory: "Digestive Health",
    riskLevel: "Normal",
  },
];

export const Pharmacy = () => {
  const navigate = useNavigate();
  return (
    <Box>
      <Box mb={6}>
        <Box
          fontSize="xl"
          fontWeight="bold"
          mb={4}
          className="flex items-center justify-between">
          <h1 className="text-xl!">Pharmacy</h1>
          <Button colorScheme="blue" variant="outline" size="md">
            <FiDownload />
            Import
          </Button>
        </Box>
        <Box
          display="flex"
          className="my-8!"
          gap={3}
          alignItems="center"
          justifyContent={"space-between"}>
          <p className="text-xl! font-medium! text-black!">All Pharmacies</p>

          <div className="flex items-center gap-4">
            <Input placeholder="All Pharmacies" maxW="250px" size="md" />
            <Button variant="outline" size="md">
              <CiFilter />
              Filter
            </Button>
            <Button variant="outline" size="md">
              <GoSortAsc />
              Sort
            </Button>
          </div>
        </Box>
      </Box>

      <Box borderWidth="1px" borderRadius="lg" overflow="hidden" bg="white">
        <Table.Root size={"md"}>
          <Table.Header bg="gray.50">
            <Table.Row>
              <Table.ColumnHeader py={4}>
                <input type="checkbox" className="w-4 h-4" />
              </Table.ColumnHeader>
              <Table.ColumnHeader
                py={4}
                fontSize="sm"
                fontWeight="600"
                color="gray.700">
                Pharmacy Name
              </Table.ColumnHeader>
              <Table.ColumnHeader
                py={4}
                fontSize="sm"
                fontWeight="600"
                color="gray.700">
                Location
              </Table.ColumnHeader>
              <Table.ColumnHeader
                py={4}
                fontSize="sm"
                fontWeight="600"
                color="gray.700">
                Last Data Sync
              </Table.ColumnHeader>
              <Table.ColumnHeader
                py={4}
                fontSize="sm"
                fontWeight="600"
                color="gray.700">
                Status
              </Table.ColumnHeader>
              <Table.ColumnHeader
                py={4}
                fontSize="sm"
                fontWeight="600"
                color="gray.700">
                Compliance
              </Table.ColumnHeader>
              <Table.ColumnHeader
                py={4}
                fontSize="sm"
                fontWeight="600"
                color="gray.700">
                Inventory Alerts
              </Table.ColumnHeader>
              <Table.ColumnHeader
                py={4}
                fontSize="sm"
                fontWeight="600"
                color="gray.700">
                Top Category
              </Table.ColumnHeader>
              <Table.ColumnHeader
                py={4}
                fontSize="sm"
                fontWeight="600"
                color="gray.700">
                Risk Level
              </Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {pharmacyData.map((pharmacy) => (
              <Table.Row
                onClick={() => navigate(`/pharmacy/${pharmacy.id}`)}
                key={pharmacy.id}
                _hover={{ bg: "gray.50" }}
                borderBottomWidth="1px">
                <Table.Cell>
                  <input type="checkbox" className="w-4 h-4" />
                </Table.Cell>
                <Table.Cell fontWeight="500" color="gray.800">
                  {pharmacy.name}
                </Table.Cell>
                <Table.Cell color="gray.600">{pharmacy.location}</Table.Cell>
                <Table.Cell color="gray.600">
                  {pharmacy.lastDataSync}
                </Table.Cell>
                <Table.Cell>
                  <Badge
                    colorScheme={pharmacy.status === "Active" ? "blue" : "gray"}
                    px={3}
                    py={1}
                    borderRadius="md"
                    fontSize="sm">
                    {pharmacy.status}
                  </Badge>
                </Table.Cell>
                <Table.Cell color="gray.700" fontWeight="500">
                  {pharmacy.compliance}
                </Table.Cell>
                <Table.Cell color="gray.700" fontWeight="500">
                  {pharmacy.inventoryAlerts}
                </Table.Cell>
                <Table.Cell color="gray.700">{pharmacy.topCategory}</Table.Cell>
                <Table.Cell color="blue.600" fontWeight="500">
                  {pharmacy.riskLevel}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </Box>
    </Box>
  );
};
